// PeptideVault v6.5 — Event handler functions

// ══════════════════════════════════════════════════════
// EVENT HANDLERS
// ══════════════════════════════════════════════════════
function setTab(tab) {
  if (tab === 'timeline') S._tlFocusToday = true
  try { history.pushState({ tab }, '', '#' + tab) } catch(e) {}
  var mainEl = document.querySelector('.main')
  if (mainEl && S.tab !== tab) {
    mainEl.style.transition = 'opacity .12s ease, transform .12s ease'
    mainEl.style.opacity = '0'
    mainEl.style.transform = 'translateY(4px)'
    setTimeout(function() {
      S.tab = tab; S.selectedPeptide = null; S.notifOpen = false; S._scrollToTop = true; render()
      var newMain = document.querySelector('.main')
      if (newMain) {
        newMain.style.opacity = '0'
        newMain.style.transform = 'translateY(6px)'
        requestAnimationFrame(function() {
          newMain.style.transition = 'opacity .2s ease, transform .2s ease'
          newMain.style.opacity = '1'
          newMain.style.transform = 'translateY(0)'
        })
      }
      if (tab === 'scanner') requestAnimationFrame(focusScanInput)
    }, 120)
  } else {
    S.tab = tab; S.selectedPeptide = null; S.notifOpen = false; S._scrollToTop = true; render()
    if (tab === 'scanner') requestAnimationFrame(focusScanInput)
  }
}
function selectPeptide(pid) {
  // Save list scroll position before entering detail view
  const mainEl = document.querySelector('.main')
  if (mainEl) S._listScrollTop = mainEl.scrollTop
  S.selectedPeptide = pid; S._scrollToTop = true; render()
}
function openModal(name, data = {}) { S.modal = name; S.modalData = data; render() }
function closeModal() {
  S.modal = null
  S.modalData = {}
  render()
  if (S._syncRefreshDeferred) {
    S._syncRefreshDeferred = false
    setTimeout(function() { pullOnly() }, 250)
  }
}
function handleOverlayClick(e) { if (e.target.classList.contains('overlay')) closeModal() }
function toggleNotif() { S.notifOpen = !S.notifOpen; render() }

function showExportModal() { openModal('export') }

function togglePepBlend() {
  const t = document.getElementById('pep-blend-toggle')
  const s = document.getElementById('pep-blend-section')
  if (!t || !s) return
  t.classList.toggle('on')
  s.style.display = t.classList.contains('on') ? 'block' : 'none'
}

let _pepBlendIdx = 0
function addPepBlendRow() {
  const container = document.getElementById('pep-blend-rows')
  if (!container) return
  const rows = container.querySelectorAll('.pep-blend-row')
  if (rows.length >= 10) { showToast('Maximum 10 components'); return }
  const i = rows.length
  const div = document.createElement('div')
  div.className = 'row pep-blend-row'
  div.style.cssText = 'gap:6px;align-items:center'
  div.dataset.idx = i
  div.style.cssText = 'display:grid;grid-template-columns:2fr 1fr 1fr auto;gap:4px;align-items:center'
  div.innerHTML = `
    <div>
      <select class="form-input form-select" id="f-pep-blend-${i}" onchange="onPepBlendSelectChange(this)">
        <option value="">— Select Peptide —</option>
        ${S.peptides.filter(x=>!x.isBlend).map(x=>`<option value="${x.id}">${esc(x.name)}</option>`).join('')}
        <option value="__custom__">Custom name…</option>
      </select>
      <input class="form-input" id="f-pep-blend-name-${i}" placeholder="Type peptide name" style="display:none;margin-top:4px">
    </div>
    <input class="form-input" id="f-pep-blend-hl-${i}" type="number" step="any" min="0" placeholder="t½ hrs">
    <input class="form-input" id="f-pep-blend-ka-${i}" type="number" step="0.1" min="0.1" placeholder="0.8">
    <button class="btn-icon" onclick="removePepBlendRow(${i})">${ICONS.trash}</button>`
  container.appendChild(div)
}

function onPepBlendSelectChange(sel) {
  const idx = sel.id.replace('f-pep-blend-', '')
  const nameInput = document.getElementById('f-pep-blend-name-' + idx)
  const hlInput   = document.getElementById('f-pep-blend-hl-' + idx)
  const kaInput   = document.getElementById('f-pep-blend-ka-' + idx)

  if (sel.value === '__custom__') {
    if (nameInput) { nameInput.style.display = 'block'; nameInput.focus() }
  } else {
    if (nameInput) { nameInput.style.display = 'none'; nameInput.value = '' }

    // Prefill half-life and ka from the selected peptide's existing data
    if (sel.value && hlInput && kaInput) {
      const pep = getPeptide(sel.value)
      if (pep) {
        if (pep.halfLife && +pep.halfLife > 0) hlInput.value = pep.halfLife
        if (pep.absorptionRate && +pep.absorptionRate > 0) kaInput.value = pep.absorptionRate
      }
    }
  }
}

function removePepBlendRow(idx) {
  const row = document.querySelector(`.pep-blend-row[data-idx="${idx}"]`)
  if (row) row.remove()
}

function getPepBlendComponents() {
  const rows = document.querySelectorAll('.pep-blend-row')
  const comps = []
  rows.forEach(row => {
    const idx       = row.dataset.idx
    const sel       = document.getElementById(`f-pep-blend-${idx}`)
    const nameInput = document.getElementById(`f-pep-blend-name-${idx}`)
    const hlInput   = document.getElementById(`f-pep-blend-hl-${idx}`)
    const kaInput   = document.getElementById(`f-pep-blend-ka-${idx}`)
    const pepId     = sel?.value || ''
    const halfLife  = hlInput?.value?.trim() || ''
    const absorptionRate = kaInput?.value?.trim() ? +kaInput.value : 0.8

    if (pepId === '__custom__') {
      const name = nameInput?.value?.trim()
      if (name) comps.push({ peptideName: name, peptideId: '', halfLife, absorptionRate })
    } else if (pepId) {
      const pep = getPeptide(pepId)
      comps.push({ peptideName: pep?.name || '', peptideId: pepId, halfLife, absorptionRate })
    }
  })
  return comps
}

function toggleBlend() {
  const tog = document.getElementById('blend-toggle')
  const sec = document.getElementById('blend-section')
  if (!tog || !sec) return
  const isOn = tog.classList.contains('on')
  if (isOn) { tog.classList.remove('on'); sec.style.display = 'none' }
  else { tog.classList.add('on'); sec.style.display = 'block' }
  S.modalData._blend = !isOn
}

function addBlendRow() {
  if (!S.modalData._comps) S.modalData._comps = []
  S.modalData._comps.push({ peptide: '', vialStrength: '' })
  // get current rows count
  const rows = document.querySelectorAll('[data-blend-row]')
  const i = rows.length
  const container = document.getElementById('blend-rows')
  if (container) {
    const div = document.createElement('div')
    div.className = 'form-row form-row-2'
    div.setAttribute('data-blend-row', i)
    div.innerHTML = `
      <div class="form-group"><label class="form-label">Peptide</label><input class="form-input" id="bc-pep-${i}" value=""></div>
      <div class="form-group"><label class="form-label">Vial Strength</label><input class="form-input" id="bc-str-${i}" value=""></div>`
    container.appendChild(div)
  }
}

function getBlendComponents() {
  const rows = document.querySelectorAll('[data-blend-row]')
  return Array.from(rows).map(r => {
    const i = r.getAttribute('data-blend-row')
    return {
      peptide: document.getElementById('bc-pep-' + i)?.value || '',
      vialStrength: document.getElementById('bc-str-' + i)?.value || ''
    }
  }).filter(c => c.peptide)
}

// ── Peptide CRUD ──────────────────────────────────────
function peptideFormCategories() {
  const selected = Array.from(document.getElementById('f-pep-cats')?.selectedOptions || []).map(o => o.value)
  const pending = Array.isArray(S.modalData?.pendingPeptideCategories) ? S.modalData.pendingPeptideCategories : []
  const typed = document.getElementById('f-pep-newcat')?.value?.trim() || ''
  const categories = []
  selected.concat(pending, typed ? [typed] : []).forEach(label => {
    const canonical = getAllCategories().find(category => category.label.toLowerCase() === label.toLowerCase())
    const value = canonical ? canonical.label : label
    if (value && !categories.some(category => category.toLowerCase() === value.toLowerCase())) categories.push(value)
  })
  if (!S.customCategories) S.customCategories = []
  categories.forEach(label => {
    if (!getAllCategories().some(category => category.label.toLowerCase() === label.toLowerCase())) {
      S.customCategories.push({ label, color:pickCategoryColor(getAllCategories().length), desc:'User-created category' })
      logChange('category', null, 'created', `Created category "${label}" with peptide`)
    }
  })
  return categories
}

function saveAddPeptide() {
  const name = document.getElementById('f-name')?.value?.trim()
  if (!name) { showToast('Name is required'); return }
  const p = {
    id: 'p_' + uid(),
    name,
    customVialName: document.getElementById('f-vial-name')?.value?.trim() || '',
    categories: peptideFormCategories(),
    unit: document.getElementById('f-unit')?.value || 'vials',
    lowStockThreshold: +(document.getElementById('f-thresh')?.value || 0),
    pepPediaUrl: document.getElementById('f-peppedia')?.value?.trim() || '',
    halfLife: document.getElementById('f-halflife')?.value?.trim() || '',
    absorptionRate: +(document.getElementById('f-ka')?.value || 0.8),
    isBlend: document.getElementById('pep-blend-toggle')?.classList.contains('on') || false,
    blendComponents: document.getElementById('pep-blend-toggle')?.classList.contains('on') ? getPepBlendComponents() : [],
    notes: document.getElementById('f-notes')?.value?.trim() || '',
    protocolDocIds: [],
    skus: [],
    createdAt: now(),
    updatedAt: now()
  }
  S.peptides.push(p)
  logChange('peptide', p.id, 'created', `Added peptide "${name}"`)
  save(); closeModal(); showToast('Peptide added')
}

function saveEditPeptide(pid) {
  const p = getPeptide(pid)
  if (!p) return
  const name = document.getElementById('f-name')?.value?.trim()
  if (!name) { showToast('Name is required'); return }
  const oldVial = p.customVialName
  p.name = name
  p.customVialName = document.getElementById('f-vial-name')?.value?.trim() || ''
  p.categories = peptideFormCategories()
  p.unit = document.getElementById('f-unit')?.value || 'vials'
  p.lowStockThreshold = +(document.getElementById('f-thresh')?.value || 0)
  p.pepPediaUrl    = document.getElementById('f-peppedia')?.value?.trim() || ''
  p.halfLife       = document.getElementById('f-halflife')?.value?.trim() || ''
  p.absorptionRate = +(document.getElementById('f-ka')?.value || 0.8)
  p.isBlend        = document.getElementById('pep-blend-toggle')?.classList.contains('on') || false
  p.blendComponents = p.isBlend ? getPepBlendComponents() : []
  p.notes = document.getElementById('f-notes')?.value?.trim() || ''
  p.updatedAt = now()
  if (oldVial !== p.customVialName && p.customVialName) {
    logChange('peptide', p.id, 'updated', `Updated vial name for "${name}" to "${p.customVialName}"`)
  }
  save(); closeModal(); render(); showToast('Peptide updated')
}

function togglePeptideArchived(pid) {
  const p = getPeptide(pid)
  if (!p) return
  p.archived = !p.archived
  p.updatedAt = now()
  logChange('peptide', p.id, 'updated', `Marked "${p.name}" ${p.archived ? 'inactive' : 'active'}`)
  save(); render()
  showToast(p.archived ? `"${p.name}" marked inactive` : `"${p.name}" reactivated`)
}

async function deletePeptide(pid) {
  const p = getPeptide(pid)
  const skuIds = new Set(((p && p.skus) || []).map(function(s){return s.id}))
  const mapped = (S.vaultAssignments || []).filter(function(a){return a.peptideId===pid || skuIds.has(a.skuId)})
  const planned = (S.inventoryReservations || []).filter(function(r){return r.peptideId===pid || skuIds.has(r.skuId)})
  if (mapped.length || planned.length) {
    showToast('Cannot delete: '+mapped.length+' mapped vial assignment(s) and '+planned.length+' active plan(s) still use this peptide','error')
    return
  }
  if (!await asyncConfirm('Delete this peptide and all its SKUs?\n\nHistorical injections and logs will be preserved.')) return
  S.peptides = S.peptides.filter(p => p.id !== pid)
  S.selectedPeptide = null
  if (p) logChange('peptide', pid, 'deleted', `Deleted peptide "${p.name}"`)
  save(); render(); showToast('Peptide deleted')
}

// ── SKU CRUD ──────────────────────────────────────────
function saveAddSku(pid) {
  const p = getPeptide(pid)
  if (!p) return
  const isBlend = document.getElementById('blend-toggle')?.classList.contains('on') || false
  const qty = +(document.getElementById('f-qty')?.value || 0)
  const s = {
    id: 's_' + uid(),
    barcode: document.getElementById('f-barcode')?.value?.trim() || '',
    vendor: document.getElementById('f-vendor')?.value?.trim() || '',
    lotNumber: document.getElementById('f-lot')?.value?.trim() || '',
    capColor: document.getElementById('f-capcolor')?.value?.trim() || '',
    purity: document.getElementById('f-purity')?.value?.trim() || '',
    vialStrength: +(document.getElementById('f-vial-strength')?.value || 0) || '',
    vialStrengthUnit: document.getElementById('f-vial-strength-unit')?.value || 'mg',
    vialStrengthMg: (document.getElementById('f-vial-strength-unit')?.value || 'mg') === 'mg' ? (+(document.getElementById('f-vial-strength')?.value || 0) || '') : '',
    testedConcentration: document.getElementById('f-conc')?.value?.trim() || '',
    concentration: document.getElementById('f-conc')?.value?.trim() || '', // legacy compatibility
    expiryDate: document.getElementById('f-exp')?.value || '',
    costPerVial: document.getElementById('f-cost')?.value?.trim() || '',
    dosesPerVial: document.getElementById('f-doses')?.value?.trim() || '',
    niimLabel: document.getElementById('f-niimlabel')?.value?.trim() || '',
    niimQR: document.getElementById('f-niimqr')?.value?.trim() || '',
    coaDocId: '',  // legacy field kept for migration
    coaDocIds: [],
    locations: [],
    isBlend,
    blendComponents: isBlend ? getBlendComponents() : [],
    transactions: qty > 0 ? [{ id:'t_'+uid(), type:'in', qty, date:now(), notes:'Initial stock' }] : []
  }
  if (!p.skus) p.skus = []
  p.skus.push(s)
  p.updatedAt = now()
  save(); closeModal(); render(); showToast('SKU added')
}

function saveEditSku(pid, sid) {
  const s = getSku(pid, sid)
  if (!s) return
  const isBlend = document.getElementById('blend-toggle')?.classList.contains('on') || false
  s.barcode = document.getElementById('f-barcode')?.value?.trim() || ''
  s.vendor = document.getElementById('f-vendor')?.value?.trim() || ''
  s.lotNumber = document.getElementById('f-lot')?.value?.trim() || ''
  s.capColor = document.getElementById('f-capcolor')?.value?.trim() || ''
  s.purity = document.getElementById('f-purity')?.value?.trim() || ''
  s.vialStrength = +(document.getElementById('f-vial-strength')?.value || 0) || ''
  s.vialStrengthUnit = document.getElementById('f-vial-strength-unit')?.value || 'mg'
  s.vialStrengthMg = s.vialStrengthUnit === 'mg' ? s.vialStrength : ''
  s.testedConcentration = document.getElementById('f-conc')?.value?.trim() || ''
  s.concentration = s.testedConcentration // legacy compatibility
  s.expiryDate = document.getElementById('f-exp')?.value || ''
  s.costPerVial  = document.getElementById('f-cost')?.value?.trim() || ''
  s.dosesPerVial = document.getElementById('f-doses')?.value?.trim() || ''
  s.niimLabel = document.getElementById('f-niimlabel')?.value?.trim() || ''
  s.niimQR = document.getElementById('f-niimqr')?.value?.trim() || ''
  s.coaDocId  = ''  // clear legacy
  s.coaDocIds = (S.coas||[]).filter(c => (c.lotIds||[]).includes(s.id) || (s.lotNumber && (c.lotIds||[]).includes(s.lotNumber))).map(c => c.documentId).filter(Boolean)
  // Peptide placement is exclusively managed by the B1/B2 vault map.
  s.locations = []
  s.isBlend = isBlend
  s.blendComponents = isBlend ? getBlendComponents() : s.blendComponents
  const p = getPeptide(pid); if (p) p.updatedAt = now()
  save(); closeModal(); render(); showToast('SKU updated')
}

async function deleteSku(pid, sid) {
  const p = getPeptide(pid)
  if (!p) return
  const mapped = (S.vaultAssignments || []).filter(function(a){return a.skuId===sid})
  const planned = (S.inventoryReservations || []).filter(function(r){return r.skuId===sid})
  if (mapped.length || planned.length) {
    showToast('Cannot delete: '+mapped.length+' mapped vial assignment(s) and '+planned.length+' active plan(s) still use this SKU','error')
    return
  }
  if (!await asyncConfirm('Delete this SKU? Historical COA and movement records will be preserved.')) return
  p.skus = p.skus.filter(s => s.id !== sid)
  p.updatedAt = now()
  save(); render(); showToast('SKU deleted')
}

function beginPeptideInventoryRemoval(pid, sid, qty, transactionNotes = '') {
  const s = getSku(pid, sid)
  if (!s) return false
  const assignments = (S.vaultAssignments || []).filter(a => a.skuId === sid && +(a.qty || 0) > 0)
  const mappedTotal = assignments.reduce((sum, a) => sum + +(a.qty || 0), 0)
  const unlocated = Math.max(0, skuQty(s) - mappedTotal)
  S._txPull = { pid, sid, qty, unlocated, assignmentIds:assignments.map(a => a.id), transactionNotes }
  openModal('pullLocation')
  return true
}

function recordTx(pid, sid, type) {
  const s = getSku(pid, sid)
  if (!s) return
  const inputId = `${type}_${sid}`
  const qty = +(document.getElementById(inputId)?.value || 1)
  if (qty <= 0) { showToast('Enter a valid quantity'); return }
  if (type === 'out' && skuQty(s) < qty) { showToast('Not enough stock'); return }

  // Peptide placement lives in vaultAssignments, not the retired SKU locations
  // array. Every removal goes through the physical-source picker so inventory
  // and the vial map are committed together.
  if (type === 'out') {
    beginPeptideInventoryRemoval(pid, sid, qty)
    return
  }

  s.transactions.push({ id:'t_'+uid(), type, qty, date:now(), notes:'' })
  const p = getPeptide(pid); if (p) p.updatedAt = now()
  save(); render(); showToast(`${type==='in'?'Added':'Removed'} ${qty} vial${qty!==1?'s':''}`)
}

function reconcileVaultRemoval(pid, sid) {
  const s = getSku(pid, sid)
  if (!s) return
  const assignments = (S.vaultAssignments || []).filter(a => a.skuId === sid && +(a.qty || 0) > 0)
  const mappedTotal = assignments.reduce((sum, a) => sum + +(a.qty || 0), 0)
  const qty = Math.max(0, mappedTotal - skuQty(s))
  if (!qty) { showToast('This SKU map already matches inventory'); return }
  S._txPull = { pid, sid, qty, unlocated:0, assignmentIds:assignments.map(a => a.id), inventoryAlreadyRemoved:true }
  openModal('pullLocation')
}

// Update the total selected across physical vault holders and the optional
// unlocated inventory pool.
function updatePullTotal(target) {
  const ctx = S._txPull
  if (!ctx) return
  const s = getSku(ctx.pid, ctx.sid)
  let total = 0
  // Include "Not in Storage" input
  const unlocEl = document.getElementById('pull-__unlocated__')
  if (unlocEl) total += +(unlocEl.value || 0)
  const assignmentIds = new Set(ctx.assignmentIds || [])
  for (const assignment of (S.vaultAssignments || []).filter(a => assignmentIds.has(a.id))) {
    const el = document.getElementById(`pull-vault-${assignment.id}`)
    if (el) total += +(el.value || 0)
  }
  const hint = document.getElementById('pull-total-hint')
  if (hint) {
    if (total === target) hint.innerHTML = `<span style="color:var(--green);font-weight:600">✓ ${total} of ${target}</span>`
    else if (total > target) hint.innerHTML = `<span style="color:var(--red)">${total} of ${target} — too many</span>`
    else hint.innerHTML = `<span style="color:var(--text3)">${total} of ${target}</span>`
  }
}

function confirmPullLocation() {
  const ctx = S._txPull
  if (!ctx) { closeModal(); return }
  const s = getSku(ctx.pid, ctx.sid)
  if (!s) { closeModal(); return }
  // Gather physical-holder amounts entered by the user.
  const pulls = []
  let totalPulled = 0
  // "Not in Storage" amount (doesn't touch any location)
  const unlocEl = document.getElementById('pull-__unlocated__')
  const unlocAmt = +(unlocEl?.value || 0)
  if (unlocAmt > 0) totalPulled += unlocAmt
  const assignmentIds = new Set(ctx.assignmentIds || [])
  for (const assignment of (S.vaultAssignments || []).filter(a => assignmentIds.has(a.id))) {
    const el = document.getElementById(`pull-vault-${assignment.id}`)
    if (!el) continue
    const amt = +(el.value || 0)
    if (amt < 0 || amt > +(assignment.qty || 0)) { showToast('A holder pull exceeds the vials stored there'); return }
    if (amt > 0) { pulls.push({ assignmentId: assignment.id, amt }); totalPulled += amt }
  }
  if (unlocAmt < 0 || unlocAmt > +(ctx.unlocated || 0)) { showToast('The unlocated pull exceeds available inventory'); return }
  if (totalPulled === 0) { showToast('Enter how many to pull from each source'); return }
  if (totalPulled !== ctx.qty) {
    showToast(`Pull amounts total ${totalPulled}, but you're removing ${ctx.qty}`); return
  }
  // Apply the inventory transaction and map changes as one save. Assignments
  // that reach zero are removed, so their holders immediately render as open.
  const locNames = []
  if (unlocAmt > 0) locNames.push(`${unlocAmt} from Not in Storage`)
  for (const pull of pulls) {
    const assignment = (S.vaultAssignments || []).find(a => a.id === pull.assignmentId)
    if (!assignment) { showToast('A selected vault holder is no longer available'); return }
    const position = (S.vaultPositions || []).find(pos => pos.id === assignment.positionId)
    const fromQty = +(assignment.qty || 0)
    const toQty = Math.max(0, fromQty - pull.amt)
    assignment.qty = toQty
    assignment.updatedAt = now()
    if (!Array.isArray(S.vaultMovements)) S.vaultMovements = []
    S.vaultMovements.push({ id:'vm_'+uid(), action:toQty ? 'inventory-removed' : 'emptied', positionId:assignment.positionId, peptideId:assignment.peptideId, skuId:assignment.skuId, fromQty, toQty, removedQty:pull.amt, at:now() })
    locNames.push(`${pull.amt} from ${position?.code || 'vault holder'}`)
  }
  S.vaultAssignments = (S.vaultAssignments || []).filter(a => +(a.qty || 0) > 0)
  if (!ctx.inventoryAlreadyRemoved) s.transactions.push({ id:'t_'+uid(), type:'out', qty:ctx.qty, date:now(), notes:`${ctx.transactionNotes ? ctx.transactionNotes+'; ' : ''}Pulled: ${locNames.join(', ')}` })
  const p = getPeptide(ctx.pid); if (p) p.updatedAt = now()
  const reconciled = !!ctx.inventoryAlreadyRemoved
  S._txPull = null
  save(); closeModal(); render()
  showToast(`${reconciled?'Reconciled map for':'Removed'} ${ctx.qty} vial${ctx.qty!==1?'s':''} (${locNames.join(', ')})`)
}

// ── Dosage Protocol CRUD ──────────────────────────────
function saveAddDosage(pid) {
  const p = getPeptide(pid)
  if (!p) return
  const name = document.getElementById('f-dpname')?.value?.trim()
  if (!name) { showToast('Name is required'); return }
  const dp = {
    id: 'dp_' + uid(),
    name,
    dose: document.getElementById('f-dpdose')?.value || '',
    doseUnit: document.getElementById('f-dpunit')?.value || 'mcg',
    frequency: document.getElementById('f-dpfreq')?.value || 'daily',
    duration: document.getElementById('f-dpdur')?.value?.trim() || '',
    route: document.getElementById('f-dproute')?.value || 'SubQ',
    status: document.getElementById('f-dpstatus')?.value || 'active',
    notes: document.getElementById('f-dpnotes')?.value?.trim() || '',
    createdAt: now()
  }
  if (!p.dosageProtocols) p.dosageProtocols = []
  p.dosageProtocols.push(dp)
  save(); closeModal(); render(); showToast('Dosage protocol added')
}

function saveEditDosage(pid, dpid) {
  const p = getPeptide(pid)
  const dp = p?.dosageProtocols?.find(x => x.id === dpid)
  if (!dp) return
  dp.name = document.getElementById('f-dpname')?.value?.trim() || dp.name
  dp.dose = document.getElementById('f-dpdose')?.value || ''
  dp.doseUnit = document.getElementById('f-dpunit')?.value || 'mcg'
  dp.frequency = document.getElementById('f-dpfreq')?.value || 'daily'
  dp.duration = document.getElementById('f-dpdur')?.value?.trim() || ''
  dp.route = document.getElementById('f-dproute')?.value || 'SubQ'
  dp.status = document.getElementById('f-dpstatus')?.value || 'active'
  dp.notes = document.getElementById('f-dpnotes')?.value?.trim() || ''
  save(); closeModal(); render(); showToast('Protocol updated')
}

function deleteDosage(pid, dpid) {
  const p = getPeptide(pid)
  if (!p) return
  p.dosageProtocols = p.dosageProtocols.filter(d => d.id !== dpid)
  save(); render(); showToast('Protocol deleted')
}

// ── Document CRUD ─────────────────────────────────────
async function saveAddDoc() {
  if (!window.api) {
    if (isElectron) {
      showToast('⚠️ Update preload.js — copy all 3 files from the zip', 5000)
    } else {
      showToast('File operations require the desktop app')
    }
    return
  }

  // Read the shared type/notes/name BEFORE the picker (modal still open)
  const sharedName  = document.getElementById('f-docname')?.value?.trim() || ''
  const type        = document.getElementById('f-doctype')?.value || 'other'
  const notes       = document.getElementById('f-docnotes')?.value?.trim() || ''

  // Pick one OR many files
  let filePaths = []
  if (window.api.pickFiles) {
    filePaths = await window.api.pickFiles({
      title: 'Select Document(s) — Shift/Cmd-click for multiple',
      filters: [
        { name: 'Documents', extensions: ['pdf','png','jpg','jpeg','docx','doc','txt'] },
        { name: 'All Files', extensions: ['*'] }
      ]
    }) || []
  } else {
    // Fallback for older preload without pickFiles
    const one = await window.api.pickFile({
      title: 'Select Document',
      filters: [{ name:'Documents', extensions:['pdf','png','jpg','jpeg','docx','doc','txt'] }, { name:'All Files', extensions:['*'] }]
    })
    if (one) filePaths = [one]
  }
  if (!filePaths.length) return

  closeModal()

  let added = 0, failed = 0
  for (let i = 0; i < filePaths.length; i++) {
    const filePath = filePaths[i]
    const fileName = filePath.split(/[\/\\]/).pop()
    // Name: if exactly one file and the user typed a name, use it; otherwise use the filename
    const baseName = (filePaths.length === 1 && sharedName) ? sharedName : fileName.replace(/\.[^.]+$/, '')
    const destName = `files${SEP()}${uid()}_${fileName}`
    const destPath = `${dataDir}${SEP()}${destName}`
    try {
      const copied = await window.api.copyFile(filePath, destPath)
      if (!copied?.ok) throw new Error(copied?.error || 'Copy failed')
      S.documents.push({
        id: 'd_' + uid(),
        name: baseName,
        type,                 // shared category applied to every file
        filePath: destName,
        originalName: fileName,
        notes,                // shared notes applied to every file
        addedAt: now()
      })
      added++
    } catch (e) {
      console.warn('Failed to import', fileName, e.message)
      failed++
    }
  }

  await save()
  render()
  if (added && !failed) showToast(added === 1 ? 'Document added' : `Added ${added} documents as ${docTypeName(type)}`)
  else if (added && failed) showToast(`Added ${added}, ${failed} failed`)
  else showToast('❌ Import failed')
}

function saveEditDoc(docId) {
  const doc = getDoc(docId)
  if (!doc) return
  doc.name = document.getElementById('f-docname')?.value?.trim() || doc.name
  doc.type = document.getElementById('f-doctype')?.value || doc.type
  doc.notes = document.getElementById('f-docnotes')?.value?.trim() || ''
  save(); closeModal(); render(); showToast('Document updated')
}

function deleteDoc(docId) {
  appConfirm('Delete this document?', () => {
    S.documents = S.documents.filter(d => d.id !== docId)
    for (const p of S.peptides) {
      p.protocolDocIds = (p.protocolDocIds||[]).filter(id => id !== docId)
      for (const s of p.skus||[]) {
        s.coaDocIds = (s.coaDocIds||[]).filter(id => id !== docId)
        if (s.coaDocId === docId) s.coaDocId = ''
      }
    }
    for (const coa of S.coas || []) {
      if (coa.documentId === docId) {
        coa.documentId = ''
        coa.migrationStatus = 'needs-review'
      }
    }
    save(); render(); showToast('Document deleted')
  })
}

// ── Protocol linking ──────────────────────────────────
function linkProtocolDoc(pid, docId) {
  const p = getPeptide(pid)
  if (!p) return
  if (!p.protocolDocIds) p.protocolDocIds = []
  if (!p.protocolDocIds.includes(docId)) p.protocolDocIds.push(docId)
  save(); render(); showToast('Protocol linked')
}

function unlinkProtocolDoc(pid, docId) {
  const p = getPeptide(pid)
  if (!p) return
  p.protocolDocIds = (p.protocolDocIds||[]).filter(id => id !== docId)
  save(); render(); showToast('Protocol unlinked')
}

// ── Pep-Pedia ─────────────────────────────────────────
async function openPepPedia(url) {
  if (!url) return
  if (window.api) {
    await window.api.openExternal(url)
  } else {
    window.open(url, '_blank')
  }
}

// ── Scanner core ──────────────────────────────────────
function handleScanKey(e) {
  if (e.key === 'Enter') { e.preventDefault(); processScan(S.scanInput) }
}

async function processScan(code) {
  const trimmed = (code||'').trim()
  if (!trimmed) return
  S.scanInput = trimmed

  // Find matching SKU
  let foundPeptide = null, foundSku = null
  for (const p of S.peptides) {
    for (const s of p.skus||[]) {
      if (s.barcode && s.barcode === trimmed) { foundPeptide = p; foundSku = s; break }
    }
    if (foundSku) break
  }

  const qty    = Math.max(1, S.scanQty || 1)
  const mode   = S.scanMode
  let logEntry = { barcode: trimmed, time: new Date().toLocaleTimeString(), mode, ok: false, msg: '' }

  if (!foundSku) {
    logEntry.msg = `❌ No match — barcode not linked to any SKU`
    updateScanDisplay(false, `❌ Not Found`, `"${trimmed}" is not linked to any SKU`)
  } else {
    const currentQty = skuQty(foundSku)
    logEntry.peptideName = foundPeptide.name
    logEntry.vendor = foundSku.vendor || ''

    if (mode === 'in') {
      foundSku.transactions.push({ id:'t_'+uid(), type:'in', qty, date:now(), notes:'Scanner' })
      // Add to a location so the per-location count stays in sync with stock
      if (foundSku.locations?.length) {
        // Add to the first location the SKU is already stored in
        foundSku.locations[0].qty = (foundSku.locations[0].qty || 0) + qty
      }
      if (foundPeptide) foundPeptide.updatedAt = now()
      await save()
      const newQty = skuQty(foundSku)
      logEntry.ok  = true
      logEntry.msg = `+${qty} → ${newQty} total`
      updateScanDisplay(true,
        `✅ ${esc(foundPeptide.name)}`,
        `+${qty} vial${qty!==1?'s':''} in · Now: ${newQty} · ${esc(foundSku.vendor||'')}`,
        'var(--greenL)', 'var(--green)')

    } else if (mode === 'out') {
      if (currentQty < qty) {
        logEntry.msg = `⚠️ Not enough stock (have ${currentQty})`
        updateScanDisplay(false,
          `⚠️ ${esc(foundPeptide.name)}`,
          `Need ${qty} but only ${currentQty} in stock`,
          'var(--yellowL)', 'var(--yellow)')
      } else {
        logEntry.ok = true
        logEntry.msg = `Choose the vault holder for ${qty} vial${qty!==1?'s':''}`
        updateScanDisplay(true,
          `📍 ${esc(foundPeptide.name)}`,
          `Choose where ${qty} vial${qty!==1?'s':''} will be removed from`,
          'var(--blueL)', 'var(--blue)')
        beginPeptideInventoryRemoval(foundPeptide.id, foundSku.id, qty, 'Scanner')
        return
      }

    } else {
      // Lookup mode — just show info
      logEntry.ok  = true
      logEntry.msg = `${currentQty} in stock · ${foundSku.purity||''}`
      updateScanDisplay(true,
        `🔍 ${esc(foundPeptide.name)}`,
        `Barcode: ${trimmed} · Vendor: ${esc(foundSku.vendor||'—')} · In stock: ${currentQty}`)
    }
  }

  // Prepend to session log
  _scanLog.unshift(logEntry)
  updateScanLog()

  // Clear input and refocus — ready for next scan immediately
  S.scanInput = ''
  setTimeout(() => {
    const hw = document.getElementById('scan-hw-input')
    if (hw) { hw.value = ''; hw.focus() }
  }, 20)
}

function updateScanDisplay(ok, title, subtitle, bgColor, borderColor) {
  const el = document.getElementById('scan-display')
  const inner = document.getElementById('scan-inner')
  if (!el || !inner) return
  el.style.borderColor  = borderColor || (ok ? 'var(--green)' : 'var(--red)')
  el.style.background   = bgColor     || (ok ? 'var(--greenL)' : 'var(--redL)')
  inner.innerHTML = `
    <div style="font-size:32px;margin-bottom:6px">${ok ? '✅' : '❌'}</div>
    <div style="font-size:16px;font-weight:600;color:var(--text)">${title}</div>
    <div style="font-size:13px;color:var(--text3);margin-top:4px">${subtitle}</div>`
  // Flash back to ready after 2.5s
  clearTimeout(el._resetTimer)
  el._resetTimer = setTimeout(() => {
    el.style.borderColor = ''
    el.style.background  = ''
    if (inner) inner.innerHTML = `
      <div style="font-size:36px;margin-bottom:8px">📷</div>
      <div style="font-size:16px;font-weight:500;color:var(--text3)">Ready to scan</div>
      <div style="font-size:13px;color:var(--text4);margin-top:4px">Point scanner here or type barcode below</div>`
  }, 2500)
}

function updateScanLog() {
  const el = document.getElementById('scan-log')
  const ct = document.getElementById('scan-log-count')
  if (!el) return
  if (ct) ct.textContent = `${_scanLog.length} scan${_scanLog.length!==1?'s':''}`
  if (!_scanLog.length) {
    el.innerHTML = `<div style="padding:24px;text-align:center;color:var(--text4);font-size:13px">No scans yet this session</div>`
    return
  }
  const modeIcon = { in:'<span style="color:var(--greenT);font-weight:700">+IN</span>', out:'<span style="color:var(--redT);font-weight:700">−OUT</span>', lookup:'<span style="color:var(--blue);font-weight:700">LOOK</span>' }
  el.innerHTML = _scanLog.map(e => `
    <div style="display:flex;align-items:center;gap:10px;padding:9px 14px;border-bottom:1px solid var(--border)">
      <span style="font-size:11px;font-weight:600;flex-shrink:0">${modeIcon[e.mode]||e.mode}</span>
      <div style="flex:1;min-width:0">
        <div style="font-size:13px;font-weight:500;color:${e.ok?'var(--text)':'var(--red)'}">${e.peptideName ? esc(e.peptideName) : `<span style="color:var(--text3)">${esc(e.barcode)}</span>`}</div>
        <div style="font-size:11px;color:var(--text3)">${esc(e.msg)}</div>
      </div>
      <span style="font-size:11px;color:var(--text4);flex-shrink:0">${e.time}</span>
    </div>`).join('')
}

// ── Export / Print ────────────────────────────────────
function showToast(msg, duration = 2500) {
  const existing = document.querySelector('.toast')
  if (existing) existing.remove()
  clearTimeout(S.toastTimer)
  const el = document.createElement('div')
  el.className = 'toast'
  el.textContent = msg
  document.body.appendChild(el)
  S.toastTimer = setTimeout(() => el.remove(), duration)
}

async function exportCSV() {
  // ── Sheet 1: Inventory ────────────────────────────────
  const invRows = [['Peptide','Vial Name','Categories','Unit','Total Qty','Status',
    'Low Stock Threshold','Half-Life','Absorption Rate','Peptide Notes','Archived',
    'SKU Barcode','Vendor','Lot','Cap Color','Purity','Linked to Protocol','Linked to COA','Vial Strength','Vial Strength Unit','Tested Concentration','Expiry','Cost/Vial','Doses/Vial','SKU Qty','SKU Notes','Reference Only','Blend Components','NIIMBOT Label','NIIMBOT QR']]
  for (const p of S.peptides) {
    const pQty = peptideQty(p)
    const status = pQty <= 0 ? 'Out of Stock' : (p.lowStockThreshold && pQty <= +p.lowStockThreshold ? 'Low Stock' : 'In Stock')
    const hasProtocol = (p.protocolDocIds||[]).length > 0 ? 'Yes' : 'No'
    const vialName = p.customVialName || ''
    if (!p.skus?.length) {
      invRows.push([p.name,vialName,(p.categories||[]).join('; '),p.unit||'',pQty,status,p.lowStockThreshold||'',p.halfLife||'',p.absorptionRate||'',p.notes||'',p.archived?'Yes':'No','','','','','',hasProtocol,'No','','','','','','','','','',''])
    } else {
      for (const s of p.skus) {
        const hasCOA = (S.coas||[]).some(c => (c.lotIds||[]).includes(s.id) || (s.lotNumber && (c.lotIds||[]).includes(s.lotNumber))) ? 'Yes' : 'No'
        invRows.push([p.name,vialName,(p.categories||[]).join('; '),p.unit||'',pQty,status,p.lowStockThreshold||'',p.halfLife||'',p.absorptionRate||'',p.notes||'',p.archived?'Yes':'No',
          s.barcode||'',s.vendor||'',s.lotNumber||'',s.capColor||'',s.purity||'',hasProtocol,hasCOA,(skuVialStrength(s)||{}).value||'',(skuVialStrength(s)||{}).unit||'',s.testedConcentration||s.concentration||'',
          s.expiryDate||'',s.costPerVial||'',s.dosesPerVial||'',skuQty(s),s.notes||'',s.referenceOnly?'Yes':'No',JSON.stringify(s.blendComponents||[]),s.niimLabel||'',s.niimQR||''])
      }
    }
  }

  // Physical placement is exported separately for the peptide vault and supplies.
  const toCSV = rows => rows.map(r => r.map(c => `"${String(c).replace(/"/g,'""')}"`).join(',')).join('\n')
  const csv = toCSV(invRows)

  const filename = `PeptideVault_Export_${localDateKey()}.csv`
  if (window.api) {
    const savePath = await window.api.showSaveDialog({ title:'Save CSV', defaultPath:filename, filters:[{name:'CSV',extensions:['csv']}] })
    if (savePath) { await window.api.writeFile(savePath, csv); showToast('CSV exported') }
  } else {
    const a = document.createElement('a')
    a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
    a.download = filename; a.click()
    showToast('CSV downloaded')
  }
}

async function downloadLocationCSV(rows, filename, title) {
  const csv = rows.map(r => r.map(v => `"${String(v ?? '').replace(/"/g,'""')}"`).join(',')).join('\n')
  if (window.api) {
    const savePath = await window.api.showSaveDialog({ title, defaultPath:filename, filters:[{name:'CSV',extensions:['csv']}] })
    if (savePath) { await window.api.writeFile(savePath, csv); showToast('CSV exported') }
  } else {
    const a = document.createElement('a'); a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv); a.download = filename; a.click(); showToast('CSV downloaded')
  }
}

async function exportPeptideVaultCSV() {
  const rows = [['Position #','Exact Position','Area','Position Label','Insert Type','Insert Order','Bin','Layer','Tray','Slot','Holder Type','Capacity','Peptide','SKU Name','Vendor','Lot','Vial Strength','Vial Strength Unit','Tested Concentration','Quantity','Count Status','Last Confirmed']]
  for (const pos of (S.vaultPositions || []).slice().sort((a,b)=>(+a.number||0)-(+b.number||0))) {
    const a = (S.vaultAssignments||[]).find(x => x.positionId === pos.id)
    const p = a && (S.peptides||[]).find(x => x.id === a.peptideId)
    const s = a && (p?.skus||[]).find(x => x.id === a.skuId)
    rows.push([pos.number,pos.code,pos.area||'tray',pos.label||'',pos.insertType||'',pos.insertOrder||'',pos.bin,pos.layer,pos.tray,pos.slot,pos.holderType,pos.capacity,p?.name||'',s?.name||s?.barcode||s?.lotNumber||'',s?.vendor||'',s?.lotNumber||'',(skuVialStrength(s)||{}).value||'',(skuVialStrength(s)||{}).unit||'',s?.testedConcentration||s?.concentration||'',a?.qty??'',a?.countStatus||'',a?.confirmedAt||''])
  }
  await downloadLocationCSV(rows, `PeptideVault_Peptide_Vault_Map_${localDateKey()}.csv`, 'Export Peptide Vault Map')
}

async function exportSupplyLocationsCSV() {
  const rows = [['Location','Total Capacity','Supply','SKU Name','Vendor','Lot','Size / Gauge','Expiry','Quantity']]
  for (const loc of (S.storageLocations || [])) {
    let found = false
    for (const supply of (S.injectionSupplies||[])) for (const sku of (supply.skus||[])) for (const placed of (sku.locations||[])) {
      if (placed.locationId !== loc.id || !(+placed.qty)) continue
      found = true
      rows.push([loc.name,loc.totalCapacity||'',supply.name,sku.name||sku.barcode||sku.lotNumber||sku.id,sku.vendor||'',sku.lotNumber||'',sku.sizeGauge||'',sku.expiryDate||'',placed.qty])
    }
    if (!found) rows.push([loc.name,loc.totalCapacity||'','(empty)','','','','','',''])
  }
  await downloadLocationCSV(rows, `PeptideVault_Supply_Locations_${localDateKey()}.csv`, 'Export Supply Locations')
}

async function exportNotInStorageCSV() {
  const rows = [['Type', 'Name', 'SKU', 'On Hand', 'In Storage', 'Not Stored']]
  for (const sup of (S.injectionSupplies || [])) {
    for (const s of (sup.skus || [])) {
      const onHand = injSupplyQty(s)
      const inStorage = (s.locations || []).reduce((a, l) => a + (l.qty || 0), 0)
      const notStored = onHand - inStorage
      if (notStored > 0) rows.push(['Supply', sup.name, s.barcode || s.vendor || s.id, onHand, inStorage, notStored])
    }
  }
  if (rows.length === 1) { showToast('All inventory is assigned to storage locations'); return }
  const csv = rows.map(r => r.map(v => `"${String(v).replace(/"/g,'""')}"`).join(',')).join('\n')
  const filename = `Not_in_Storage_${localDateKey()}.csv`
  if (window.api) {
    const savePath = await window.api.showSaveDialog({ title:'Export Not in Storage', defaultPath:filename, filters:[{name:'CSV',extensions:['csv']}] })
    if (savePath) { await window.api.writeFile(savePath, csv); showToast('Exported: ' + filename) }
  } else {
    const blob = new Blob([csv], { type:'text/csv' })
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = filename; a.click()
    showToast('Exported: ' + filename)
  }
}

async function exportJSON() {
  // v6.5: manual exports must be a complete recovery artifact, not a legacy-only dump.
  // Keep this list aligned with storage.js persistence/sync keys.
  const payload = {
    peptides: S.peptides || [], documents: S.documents || [], storageLocations: S.storageLocations || [],
    injections: S.injections || [], healthData: S.healthData || [], notes: S.notes || [], labResults: S.labResults || [],
    supplements: S.supplements || [], users: S.users || [], peptideLibrary: S.peptideLibrary || [], changeLog: S.changeLog || [],
    customCategories: S.customCategories || [], refillLog: S.refillLog || [], injectionSupplies: S.injectionSupplies || [],
    peptidePens: S.peptidePens || [], vendors: S.vendors || [], cycleTimelines: S.cycleTimelines || [], blends: S.blends || [],
    protocols: S.protocols || [], scenarios: S.scenarios || [], inventoryReservations: S.inventoryReservations || [],
    regimenVersions: S.regimenVersions || [], coas: S.coas || [], labMarkerDictionary: S.labMarkerDictionary || [],
    savedViews: S.savedViews || [], trash: S.trash || [], snapshots: S.snapshots || [], reportPresets: S.reportPresets || [],
    masterPlanRules: S.masterPlanRules || [], protocolDependencies: S.protocolDependencies || [],
    vaultPositions: S.vaultPositions || [], vaultAssignments: S.vaultAssignments || [],
    vaultMovements: S.vaultMovements || [], vaultReconciliations: S.vaultReconciliations || [],
    protocolRequirements: S.protocolRequirements || [], mobilePickingSheets: S.mobilePickingSheets || [],
    supplementLabelReviews: S.supplementLabelReviews || [], preparationBatches: S.preparationBatches || [],
    _schemaVersion: S._schemaVersion || 1,
    emergencyContact: S.settings.emergencyContact || {}, iceData: S.settings.iceData || {},
    exportedAt: now(),
  }
  const data = JSON.stringify(payload, null, 2)
  const filename = `PeptideVault_backup_${localDateKey()}.json`
  if (window.api) {
    const savePath = await window.api.showSaveDialog({ title:'Save Backup', defaultPath:filename, filters:[{name:'JSON',extensions:['json']}] })
    if (savePath) { await window.api.writeFile(savePath, data); showToast('Complete backup exported') }
  } else {
    const blob = new Blob([data], { type:'application/json' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = filename; a.click()
    setTimeout(function(){ URL.revokeObjectURL(a.href) }, 1000)
    showToast('Complete backup downloaded')
  }
}

async function restoreImportedBackupText(text) {
  try {
    const d = JSON.parse(text)
    if (!d || typeof d !== 'object' || Array.isArray(d)) { showToast('Invalid backup file'); return }
    if (await asyncConfirm('This will replace all current data. Continue?')) {
      // Preserve a local restore point before replacing the current state.
      if (typeof writeLocalBackup === 'function' && typeof dataRecordCount === 'function' && dataRecordCount() > 0) await writeLocalBackup('before-manual-import')
      const keys = ['peptides','documents','storageLocations','injections','healthData','notes','labResults','supplements','users','peptideLibrary','changeLog','customCategories','refillLog','injectionSupplies','peptidePens','vendors','cycleTimelines','blends','protocols','scenarios','inventoryReservations','regimenVersions','coas','labMarkerDictionary','savedViews','trash','snapshots','reportPresets','masterPlanRules','protocolDependencies','vaultPositions','vaultAssignments','vaultMovements','vaultReconciliations','protocolRequirements','mobilePickingSheets','supplementLabelReviews','preparationBatches']
      for (const k of keys) S[k] = d[k] || []
      if (d._schemaVersion) S._schemaVersion = d._schemaVersion
      // A confirmed full restore establishes a new local baseline. Do not carry
      // stale per-domain cloud revisions into the user's subsequent manual push.
      S._syncRevisions = {}
      if (d.emergencyContact) S.settings.emergencyContact = d.emergencyContact
      if (d.iceData) S.settings.iceData = d.iceData
      migrateLegacy()
      await save()
      // An imported catalog can remove the COA that was open before restore.
      // Return to the list so the UI never retains a stale detail record ID.
      if (typeof window !== 'undefined' && typeof window.backToCoaList === 'function') window.backToCoaList()
      else render()
      showToast('Complete backup imported successfully')
    }
  } catch (e) {
    console.error('Backup import failed:', e)
    showToast('Invalid backup file')
  }
}

async function importData() {
  // Electron: keep the native file picker. Browser/PWA: use a standard file input.
  if (window.api && window.api.pickFile && window.api.readFile) {
    const fp = await window.api.pickFile({ title:'Import Backup', filters:[{name:'JSON',extensions:['json']}] })
    if (!fp) return
    const res = await window.api.readFile(fp)
    if (!res.ok) { showToast('Failed to read file'); return }
    await restoreImportedBackupText(res.data)
    return
  }

  const input = document.createElement('input')
  input.type = 'file'
  input.accept = '.json,application/json'
  input.style.display = 'none'
  input.addEventListener('change', async function() {
    const file = input.files && input.files[0]
    try {
      if (!file) return
      if (!/\.json$/i.test(file.name || '')) { showToast('Choose a JSON backup file'); return }
      const text = await file.text()
      await restoreImportedBackupText(text)
    } catch (e) {
      console.error('Browser backup import failed:', e)
      showToast('Failed to read backup file')
    } finally {
      input.remove()
    }
  }, { once:true })
  document.body.appendChild(input)
  input.click()
}

async function exportData() { exportJSON() }

async function printReport() {
  if (window.api) {
    window.api.print()
  } else {
    window.print()
  }
}

async function clearAllData() {
  if (!await asyncConfirm('Delete ALL data?\n\nThis removes peptides, documents, supplements, locations, injections, health data, lab results, notes, and more.\n\nThis cannot be undone.')) return
  // Save a backup BEFORE wiping, so this is always recoverable locally
  await writeLocalBackup('before-clear-all')
  // Second confirmation makes accidental total wipes much harder
  if (!await asyncConfirm('Are you absolutely sure?\n\nA local backup was just saved, but this clears everything on this device.')) { showToast('Cancelled — nothing deleted'); return }
  S.peptides = []; S.documents = []; S.storageLocations = []; S.injections = []
  S.healthData = []; S.notes = []; S.labResults = []; S.supplements = []
  S.users = []; S.peptideLibrary = []; S.changeLog = []
  S.customCategories = []
  S.refillLog = []
  S.injectionSupplies = []
  S.peptidePens = []
  S.vendors = []
  S.cycleTimelines = []
  S.blends = []
  S.protocols = []; S.scenarios = []; S.inventoryReservations = []
  S.regimenVersions = []; S.coas = []; S.labMarkerDictionary = []; S.savedViews = []
  S.trash = []; S.snapshots = []; S.reportPresets = []; S.masterPlanRules = []; S.protocolDependencies = []
  S.vaultPositions = []; S.vaultAssignments = []; S.vaultMovements = []; S.vaultReconciliations = []
  S.protocolRequirements = []; S.mobilePickingSheets = []; S.supplementLabelReviews = []; S.preparationBatches = []
  migrateLegacy() // re-seed default users and library
  // Do NOT auto-push this empty state to the cloud — the save() guard blocks it,
  // protecting the cloud backup. Use the cloud sync buttons explicitly if you truly
  // want to clear the cloud too.
  await save(); render(); showToast('All data cleared (local backup saved)')
}


// ══════════════════════════════════════════════════════
// PROTOCOL / SCENARIO / RESERVATION HANDLERS (v6.1)
// ══════════════════════════════════════════════════════

function saveProtocolFromModal(existingId) {
  var existingProtocol = existingId ? (S.protocols||[]).find(function(p){return p.id===existingId}) : null
  var isExplicitSchedule = !!(existingProtocol && existingProtocol.scheduleMode === 'explicit' && (existingProtocol.explicitEntries||[]).length)
  var peptideSelect = document.getElementById('proto-peptide')
  var peptide = peptideSelect ? (S.peptides||[]).find(function(p){return p.id===peptideSelect.value}) : null
  var startDate = (document.getElementById('proto-start')||{}).value || ''
  var endDate = (document.getElementById('proto-end')||{}).value || ''
  // Validate dates
  if (startDate && endDate && endDate < startDate) { showToast('End date must be after start date'); return }
  // Collect weekdays
  var weekdayEls = document.querySelectorAll('.proto-weekday:checked')
  var weekdays = []
  weekdayEls.forEach(function(el) { weekdays.push(parseInt(el.value)) })
  // Collect phases
  var phaseRows = document.querySelectorAll('.proto-phase-row')
  var phases = []
  phaseRows.forEach(function(row) {
    var name = (row.querySelector('[data-phase-name]')||{}).value || ''
    var startDay = parseInt((row.querySelector('[data-phase-start]')||{}).value) || 0
    var endDay = parseInt((row.querySelector('[data-phase-end]')||{}).value) || 0
    var doseAmount = (row.querySelector('[data-phase-dose]')||{}).value || ''
    var doseUnit = (row.querySelector('[data-phase-unit]')||{}).value || 'mcg'
    if (name || doseAmount) phases.push({ name: name, startDay: startDay, endDay: endDay, doseAmount: doseAmount, doseUnit: doseUnit })
  })
  // Collect breaks
  var breakRowEls = document.querySelectorAll('.proto-break-row')
  var breaks = []
  breakRowEls.forEach(function(row) {
    var bs = (row.querySelector('[data-break-start]')||{}).value || ''
    var be = (row.querySelector('[data-break-end]')||{}).value || ''
    var reason = (row.querySelector('[data-break-reason]')||{}).value || ''
    if (bs && be) breaks.push({ startDate: bs, endDate: be, reason: reason })
  })
  var data = {
    name: (document.getElementById('proto-name')||{}).value || '',
    peptideId: peptideSelect ? peptideSelect.value : '',
    peptideName: peptide ? peptide.name : '',
    startDate: startDate,
    endDate: endDate,
    frequency: (document.getElementById('proto-freq')||{}).value || 'daily',
    weekdays: weekdays,
    doseAmount: (document.getElementById('proto-dose')||{}).value || '',
    doseUnit: (document.getElementById('proto-unit')||{}).value || 'mcg',
    phases: phases,
    breaks: breaks,
    status: (document.getElementById('proto-status')||{}).value === 'paused' ? 'paused' : 'upcoming',
    notes: (document.getElementById('proto-notes')||{}).value || '',
  }
  if (!data.name && !data.peptideName) { showToast('Enter a protocol name or select a peptide'); return }
  if (!data.startDate) { showToast('Start date is required'); return }
  if (data.status !== 'paused' && typeof automaticProtocolStatus === 'function') data.status = automaticProtocolStatus(data)
  if (!isExplicitSchedule && data.frequency === 'custom' && weekdays.length === 0) { showToast('Select at least one weekday for custom frequency'); return }
  if (existingId) data.id = existingId
  // Imported Master Plan schedules are authoritative. Editing metadata must never
  // collapse them into a rule-based/custom schedule or replace dated entries.
  if (isExplicitSchedule) {
    data.scheduleMode = 'explicit'
    data.explicitEntries = existingProtocol.explicitEntries
    data.sourceExactSchedule = existingProtocol.sourceExactSchedule
    data.sourceRawDoseCells = existingProtocol.sourceRawDoseCells
    data.startDate = existingProtocol.startDate
    data.endDate = existingProtocol.endDate
    data.frequency = existingProtocol.frequency
    data.weekdays = existingProtocol.weekdays || []
    data.doseAmount = existingProtocol.doseAmount
    data.doseUnit = existingProtocol.doseUnit
    data.phases = existingProtocol.phases || []
    data.breaks = existingProtocol.breaks || []
  }
  saveProtocol(data)
}

function saveScenarioFromModal(existingId) {
  var data = {
    name: (document.getElementById('scen-name')||{}).value || '',
    startDate: (document.getElementById('scen-start')||{}).value || '',
    endDate: (document.getElementById('scen-end')||{}).value || '',
    frequency: (document.getElementById('scen-freq')||{}).value || 'daily',
    doseAmount: (document.getElementById('scen-dose')||{}).value || '',
    doseUnit: (document.getElementById('scen-unit')||{}).value || 'mcg',
    notes: (document.getElementById('scen-notes')||{}).value || '',
  }
  if (existingId) {
    data.id = existingId
  } else {
    // New scenario — clone from base protocol
    var baseId = (document.getElementById('scen-base')||{}).value
    if (!baseId) { showToast('Select a base protocol'); return }
    var base = (S.protocols||[]).find(function(p){return p.id===baseId})
    if (!base) { showToast('Base protocol not found'); return }
    data.baseProtocolId = baseId
    data.peptideId = base.peptideId
    data.peptideName = base.peptideName
    if (!data.startDate) data.startDate = base.startDate
    if (!data.endDate) data.endDate = base.endDate
    if (!data.frequency || data.frequency === 'daily') data.frequency = base.frequency
    if (!data.doseAmount) data.doseAmount = base.doseAmount
    if (!data.doseUnit || data.doseUnit === 'mcg') data.doseUnit = base.doseUnit
  }
  saveScenario(data)
}

function saveReservationFromModal() {
  var peptideId = (document.getElementById('res-peptide')||{}).value
  var protocolId = (document.getElementById('res-protocol')||{}).value
  var qty = parseInt((document.getElementById('res-qty')||{}).value) || 1
  var skuId = (document.getElementById('res-sku')||{}).value || ''
  if (!peptideId || !protocolId) { showToast('Select a peptide and protocol'); return }
  reserveInventory(peptideId, protocolId, qty, skuId)
  closeModal()
}

function openProtocolVialPlan(protocolId) {
  var protocol = (S.protocols || []).find(function(p) { return p.id === protocolId })
  if (!protocol) { showToast('Protocol not found'); return }
  var existingRows = (S.inventoryReservations || [])
    .filter(function(r) { return r.protocolId === protocolId && r.workflowStatus !== 'completed' && r.workflowStatus !== 'picked' && r.workflowStatus !== 'in_use' && !r.pickConfirmedAt && !r.pickedAt })
    .sort(function(a, b) { return (Number(a.sequence) || 9999) - (Number(b.sequence) || 9999) })
  var plan = []
  existingRows.forEach(function(r) {
      var count = Math.max(1, Number(r.qty != null ? r.qty : r.quantity) || 1)
      for (var i=0;i<count;i++) {
        plan.push({ skuId:r.skuId||'', peptideId:r.peptideId||protocol.peptideId||'' })
      }
    })
  openModal('protocolVialPlan', { protocolId: protocolId, vialPlan: plan })
}

function normalizeProtocolBlendName(value) {
  return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g,'')
}

function protocolVialComponents(protocol) {
  var peptides = S.peptides || []
  var primary = peptides.find(function(p) { return p.id === protocol.peptideId || p.name === protocol.peptideName })
  var name = String(protocol.name || protocol.peptideName || '')
  var blendMatch = name.match(/^(.+?)\s+(?:AM|PM)\s+Blend(?:\s*[—-].*)?$/i)
  if (!blendMatch || blendMatch[1].indexOf('/') < 0) return primary ? [{ name:primary.name, options:[primary] }] : []
  return blendMatch[1].split('/').map(function(componentName) {
    var wanted = normalizeProtocolBlendName(componentName)
    var options = peptides.filter(function(peptide){
      var candidate = normalizeProtocolBlendName(peptide.name)
      return candidate === wanted || candidate.indexOf(wanted) >= 0 || wanted.indexOf(candidate) >= 0
    }).sort(function(a,b){
      var aExact = normalizeProtocolBlendName(a.name) === wanted ? 0 : 1
      var bExact = normalizeProtocolBlendName(b.name) === wanted ? 0 : 1
      return aExact-bExact || String(a.name||'').localeCompare(String(b.name||''),undefined,{numeric:true,sensitivity:'base'})
    })
    return { name:String(componentName || '').trim(), options:options }
  })
}

function protocolVialPeptides(protocol) {
  return protocolVialComponents(protocol).map(function(component){
    return component.options[0] || { id:'', name:component.name, missing:true, skus:[] }
  })
}

function setProtocolBlendComponentPeptide(componentIndex, peptideId) {
  if (!S.modalData.blendPeptideChoices) S.modalData.blendPeptideChoices = {}
  S.modalData.blendPeptideChoices[String(componentIndex)] = peptideId || ''
  render()
}

function addProtocolVialPlanStep(peptideId) {
  var selectId = peptideId ? 'vial-plan-sku-' + peptideId : 'vial-plan-sku'
  var skuId = (document.getElementById(selectId) || {}).value || ''
  if (!skuId) { showToast('Select a vial'); return }
  var plan = S.modalData.vialPlan || (S.modalData.vialPlan = [])
  var protocolId = S.modalData.protocolId
  var peptide = (S.peptides || []).find(function(p){ return p.id === peptideId })
  var sku = ((peptide && peptide.skus) || []).find(function(s){ return s.id === skuId })
  if (!sku) (S.peptides || []).some(function(p) {
    var found = (p.skus || []).find(function(s) { return s.id === skuId })
    if (found) { peptide = p; sku = found; return true }
    return false
  })
  if (!sku) { showToast('Vial SKU not found'); return }
  var reservedElsewhere = (S.inventoryReservations || []).reduce(function(total, r) {
    var stillWaiting = r.workflowStatus !== 'picked' && !r.pickConfirmedAt && r.workflowStatus !== 'completed'
    return total + (r.skuId === skuId && r.protocolId !== protocolId && stillWaiting ? Math.max(0, Number(r.qty != null ? r.qty : r.quantity) || 0) : 0)
  }, 0)
  var alreadyPlanned = plan.filter(function(step) { return step.skuId === skuId }).length
  if (alreadyPlanned + reservedElsewhere >= skuQty(sku)) { showToast('No more unreserved vials are available for this SKU'); return }
  plan.push({ skuId: skuId, peptideId:peptide && peptide.id || peptideId || '' })
  render()
}

function moveProtocolVialPlanStep(index, direction) {
  var plan = S.modalData.vialPlan || []
  var target = index + direction
  if (index < 0 || target < 0 || index >= plan.length || target >= plan.length) return
  var item = plan[index]
  plan[index] = plan[target]
  plan[target] = item
  render()
}

function removeProtocolVialPlanStep(index) {
  var plan = S.modalData.vialPlan || []
  if (index >= 0 && index < plan.length) plan.splice(index, 1)
  render()
}

function toggleProtocolVialCombination(index) {
  var plan = S.modalData.vialPlan || []
  if (index <= 0 || index >= plan.length) return
  plan[index].combineWithPrevious = !plan[index].combineWithPrevious
  render()
}

function setProtocolVialPlanPen(penId) {
  S.modalData.penId = penId || ''
}

function setProtocolVialPlanExpectedInjections(loadGroup, count) {
  var plan = S.modalData.vialPlan || []
  var currentGroup = 0
  count = Math.max(0, Math.floor(Number(count) || 0))
  plan.forEach(function(step, index) {
    if (index === 0 || !step.combineWithPrevious) currentGroup++
    if (currentGroup === Number(loadGroup)) step.expectedInjections = count
  })
}

function saveProtocolVialPlanFromModal() {
  var protocolId = S.modalData.protocolId
  var protocol = (S.protocols || []).find(function(p) { return p.id === protocolId })
  if (!protocol) { showToast('Protocol not found'); return }
  var plan = S.modalData.vialPlan || []
  if (plan.some(function(step){ return !(S.peptides || []).some(function(p){ return p.id === step.peptideId && (p.skus || []).some(function(s){ return s.id === step.skuId }) }) })) {
    showToast('One or more selected vials no longer match a peptide SKU','error'); return
  }
  S.inventoryReservations = (S.inventoryReservations || []).filter(function(r) {
    return r.protocolId !== protocolId || r.workflowStatus === 'completed' || r.workflowStatus === 'picked' || !!r.pickConfirmedAt
  })
  var newRows = []
  plan.forEach(function(step, index) {
    newRows.push({
      id: uid(), peptideId: step.peptideId || protocol.peptideId || '', protocolId: protocolId, skuId: step.skuId,
      qty: 1, sequence: index + 1,
      reservationType: 'shopping-list', workflowStatus:'upcoming', reservedAt: now()
    })
  })
  assignPickingLocationsToPlanRows(newRows, protocolId)
  S.inventoryReservations = (S.inventoryReservations || []).concat(newRows)
  save()
  closeModal()
  showToast(plan.length ? 'Shopping list saved with storage locations' : 'Shopping list cleared')
}

function openManualVialPicker() {
  openModal('manualVialPicker', { contextProtocolId:'', peptideId:'', skuId:'', quantity:1 })
}

function setManualVialContext(protocolId) {
  S.modalData.contextProtocolId = protocolId || ''
  if (protocolId) {
    var protocol = (S.protocols || []).find(function(item){ return item.id === protocolId })
    var peptide = protocol && (S.peptides || []).find(function(item){ return item.id === protocol.peptideId || item.name === protocol.peptideName })
    S.modalData.peptideId = peptide && peptide.id || ''
  }
  S.modalData.skuId = ''
  render()
}

function setManualVialPeptide(peptideId) {
  S.modalData.peptideId = peptideId || ''
  S.modalData.skuId = ''
  render()
}

function saveManualVialsToShoppingList() {
  var peptideId = S.modalData.peptideId || (document.getElementById('manual-vial-peptide') || {}).value || ''
  var skuId = (document.getElementById('manual-vial-sku') || {}).value || S.modalData.skuId || ''
  var quantity = Math.max(1, Math.floor(Number((document.getElementById('manual-vial-qty') || {}).value || S.modalData.quantity || 1)))
  var peptide = (S.peptides || []).find(function(item){ return item.id === peptideId })
  var sku = ((peptide && peptide.skus) || []).find(function(item){ return item.id === skuId })
  if (!peptide || !sku) { showToast('Choose a peptide and vial SKU'); return }
  var alreadyQueued = (S.inventoryReservations || []).reduce(function(total,row){
    var waiting = row.workflowStatus !== 'picked' && row.workflowStatus !== 'completed' && !row.pickConfirmedAt
    return total + (waiting && row.skuId === skuId ? Math.max(1,Number(row.qty != null ? row.qty : row.quantity)||1) : 0)
  },0)
  if (quantity + alreadyQueued > skuQty(sku)) { showToast('Only '+Math.max(0,skuQty(sku)-alreadyQueued)+' uncommitted vial(s) are available for this SKU','error'); return }
  var context = (S.protocols || []).find(function(item){ return item.id === S.modalData.contextProtocolId })
  var listId = 'manual_'+uid()
  var label = context ? (context.name || context.peptideName || 'Continuous protocol') : 'General storage pull'
  var rows = []
  for (var i=0;i<quantity;i++) rows.push({
    id:uid(), peptideId:peptide.id, protocolId:'', skuId:sku.id, qty:1, sequence:i+1,
    reservationType:'manual-shopping-list', shoppingListId:listId, manualLabel:label,
    sourceProtocolId:context && context.id || '', workflowStatus:'upcoming', reservedAt:now(), createdAt:now()
  })
  assignPickingLocationsToPlanRows(rows,listId)
  S.inventoryReservations = (S.inventoryReservations || []).concat(rows)
  save(); closeModal(); setTab('allocation')
  showToast(quantity+' vial'+(quantity===1?'':'s')+' added to the shopping list')
}


// ── Phase/Break row helpers for Protocol modal ──
function addProtoPhaseRow() {
  var container = document.getElementById('proto-phases')
  if (!container) return
  var row = document.createElement('div')
  row.className = 'proto-phase-row'
  row.style.cssText = 'display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr auto;gap:6px;align-items:end;margin-bottom:6px'
  row.innerHTML = '<div class="form-group"><label style="font-size:11px">Name</label><input class="input" style="font-size:12px" data-phase-name placeholder="e.g. Loading"></div>' +
    '<div class="form-group"><label style="font-size:11px">Start Day</label><input class="input" style="font-size:12px" type="number" data-phase-start value="0"></div>' +
    '<div class="form-group"><label style="font-size:11px">End Day</label><input class="input" style="font-size:12px" type="number" data-phase-end value="7"></div>' +
    '<div class="form-group"><label style="font-size:11px">Dose</label><input class="input" style="font-size:12px" type="number" step="any" data-phase-dose></div>' +
    '<div class="form-group"><label style="font-size:11px">Unit</label><select class="input" style="font-size:12px" data-phase-unit><option>mcg</option><option>mg</option><option>IU</option><option>units</option></select></div>' +
    '<button class="btn btn-ghost btn-xs" onclick="this.closest(\'.proto-phase-row\').remove()" style="color:var(--red);margin-bottom:6px">\u2715</button>'
  container.appendChild(row)
}

function addProtoBreakRow() {
  var container = document.getElementById('proto-breaks')
  if (!container) return
  var row = document.createElement('div')
  row.className = 'proto-break-row'
  row.style.cssText = 'display:grid;grid-template-columns:1fr 1fr 2fr auto;gap:6px;align-items:end;margin-bottom:6px'
  row.innerHTML = '<div class="form-group"><label style="font-size:11px">Start</label><input class="input" style="font-size:12px" type="date" data-break-start></div>' +
    '<div class="form-group"><label style="font-size:11px">End</label><input class="input" style="font-size:12px" type="date" data-break-end></div>' +
    '<div class="form-group"><label style="font-size:11px">Reason</label><input class="input" style="font-size:12px" data-break-reason></div>' +
    '<button class="btn btn-ghost btn-xs" onclick="this.closest(\'.proto-break-row\').remove()" style="color:var(--red);margin-bottom:6px">\u2715</button>'
  container.appendChild(row)
}

// BN48: Density mode
function setDensityMode(mode) {
  S._densityMode = mode
  document.body.classList.remove('density-compact')
  if (mode === 'compact') document.body.classList.add('density-compact')
  if (typeof saveSettings === 'function') saveSettings()
  render()
}

// BN40+41: AI context assembler with privacy gate
function buildAIContext() {
  var ctx = {}
  var priv = S._aiPrivacy || {}
  if (priv.peptides !== false) ctx.peptides = (S.peptides || []).map(function(p) { return { name: p.name, skuCount: (p.skus||[]).length } })
  if (priv.protocols !== false) ctx.protocols = (S.protocols || []).filter(function(p) { return p.status === 'active' }).map(function(p) { return { name: p.name, peptideName: p.peptideName, startDate: p.startDate, endDate: p.endDate, doseAmount: p.doseAmount, doseUnit: p.doseUnit, frequency: p.frequency } })
  if (priv.inventory !== false) {
    var forecast = typeof forecastInventory === 'function' ? forecastInventory(S.protocols||[], S.peptides||[], S.inventoryReservations||[], 90) : []
    ctx.inventory = forecast.map(function(r) { return { peptide: r.peptideName, onHand: r.onHand, available: r.available, shortfall: r.shortfall } })
  }
  if (priv.labs !== false) ctx.labResults = (S.labResults || []).slice(-3).map(function(l) { return { date: l.date, panelName: l.panelName, markerCount: (l.markers||[]).length } })
  if (priv.health !== false) ctx.healthSummary = { records: (S.healthData||[]).length }
  if (priv.notes !== false) ctx.recentNotes = (S.notes||[]).slice(-3).map(function(n) { return { title: n.title, date: n.date } })
  return ctx
}

export {
  setTab,
  selectPeptide,
  openModal,
  closeModal,
  handleOverlayClick,
  toggleNotif,
  showExportModal,
  togglePepBlend,
  _pepBlendIdx,
  addPepBlendRow,
  onPepBlendSelectChange,
  removePepBlendRow,
  getPepBlendComponents,
  toggleBlend,
  addBlendRow,
  getBlendComponents,
  saveAddPeptide,
  saveEditPeptide,
  togglePeptideArchived,
  deletePeptide,
  saveAddSku,
  saveEditSku,
  deleteSku,
  beginPeptideInventoryRemoval,
  recordTx,
  reconcileVaultRemoval,
  updatePullTotal,
  confirmPullLocation,
  saveAddDosage,
  saveEditDosage,
  deleteDosage,
  saveAddDoc,
  saveEditDoc,
  deleteDoc,
  linkProtocolDoc,
  unlinkProtocolDoc,
  openPepPedia,
  handleScanKey,
  processScan,
  updateScanDisplay,
  updateScanLog,
  showToast,
  exportCSV,
  exportPeptideVaultCSV,
  exportSupplyLocationsCSV,
  exportNotInStorageCSV,
  exportJSON,
  importData,
  exportData,
  printReport,
  clearAllData,
  saveProtocolFromModal,
  saveScenarioFromModal,
  saveReservationFromModal,
  openProtocolVialPlan,
  normalizeProtocolBlendName,
  protocolVialComponents,
  protocolVialPeptides,
  setProtocolBlendComponentPeptide,
  addProtocolVialPlanStep,
  moveProtocolVialPlanStep,
  removeProtocolVialPlanStep,
  toggleProtocolVialCombination,
  setProtocolVialPlanPen,
  setProtocolVialPlanExpectedInjections,
  saveProtocolVialPlanFromModal,
  openManualVialPicker,
  setManualVialContext,
  setManualVialPeptide,
  saveManualVialsToShoppingList,
  addProtoPhaseRow,
  addProtoBreakRow,
  setDensityMode,
  buildAIContext
}
